"use client";

import { HourglassIcon } from "./icons";

/**
 * 読み込み中を示す砂時計ピル（丸バッジ + ラベル）。
 * checkout-date-picker / 部屋タイプ予約カレンダー双方の「読み込み中」表示で共有する。
 */
export function LoadingIndicator({ label }: { label: string }) {
  return (
    <div className="bg-dx-surface-raised flex items-center gap-[6px] rounded-full px-[16px] py-[12px] shadow-[0px_6px_14px_rgba(0,0,0,0.1),0px_0px_0px_rgba(0,0,0,0.02)]">
      <HourglassIcon className="text-dx-text-default size-[16px]" />
      <span className="font-notojp text-dx-text-sub text-[12px] leading-[18px]">
        {label}
      </span>
    </div>
  );
}
